import React from 'react';
import {Text, TextButton, IconButton} from '@wix/wix-ui-tpa/cssVars';
import {Edit as EditIcon} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './SummaryTitle.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {BiMobilePosition} from '../../../../domain/utils/bi.util';
import {A11yIds, SPECS} from '../../../../common/constants';
import {useExperiments} from '@wix/yoshi-flow-editor';

export enum SummaryTitleDataHooks {
  root = 'SummaryTitleDataHooks.root',
  titleText = 'SummaryTitleDataHooks.title',
  editCartButton = 'SummaryTitleDataHooks.editCartButton',
  editCartIconButton = 'SummaryTitleDataHooks.editCartIconButton',
  numberOfItems = 'SummaryTitleDataHooks.numberOfItems',
}
export interface SummaryTitleProps {
  shouldShowNumberOfItems?: boolean;
}
export const SummaryTitle = ({shouldShowNumberOfItems}: SummaryTitleProps) => {
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const {
    navigationStore: {editCartUrl, clickOnEditCart, isDonationsTheme},
    checkoutStore: {cart},
    checkoutSettingsStore: {checkoutContent},
    isOneColumnView,
  } = useControllerProps();
  const summaryTitleText = isDonationsTheme
    ? localeKeys.checkout.donations.donation_summary()
    : localeKeys.checkout.order_summary.$value();
  const summaryTitleTextWithOverride = checkoutContent?.orderSummary ?? summaryTitleText;

  const numberOfItemsText = checkoutUIRevampOrderSummary
    ? localeKeys.checkout.order_summary.numberOfItems({
        numberOfItems: cart.numberOfItems,
      })
    : `(${cart.numberOfItems})`;
  const handleEditCartClick = () => {
    clickOnEditCart(isOneColumnView ? BiMobilePosition.top : undefined);
  };

  return (
    <div
      data-hook={SummaryTitleDataHooks.root}
      className={checkoutUIRevampOrderSummary ? classes.title : classes.titleOld}
      id={A11yIds.SummarySection}>
      <div className={classes.header}>
        <Text tagName={'h2'} className={classes.titleText} data-hook={SummaryTitleDataHooks.titleText}>
          {summaryTitleTextWithOverride}
        </Text>{' '}
        {(shouldShowNumberOfItems || checkoutUIRevampOrderSummary) && (
          <Text
            data-hook={SummaryTitleDataHooks.numberOfItems}
            className={classes.numberOfItems}
            aria-label={localeKeys.checkout.orderSummary.itemAmount_ariaLabel({
              itemNumber: cart.numberOfItems,
            })}>
            {numberOfItemsText}
          </Text>
        )}
      </div>
      {cart.currentCart && (
        <div className={classes.editCartButtonWrapper}>
          {checkoutUIRevampOrderSummary ? (
            <IconButton
              as={'a'}
              href={editCartUrl}
              onClick={handleEditCartClick}
              className={classes.editCartButton}
              icon={<EditIcon />}
              aria-label={localeKeys.checkout.edit_cart()}
              data-hook={SummaryTitleDataHooks.editCartIconButton}
            />
          ) : (
            <TextButton
              as={'a'}
              href={editCartUrl}
              onClick={handleEditCartClick}
              className={classes.editCartButton}
              data-hook={SummaryTitleDataHooks.editCartButton}>
              {localeKeys.checkout.edit_cart()}
            </TextButton>
          )}
        </div>
      )}
    </div>
  );
};
